import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import {Router} from "@angular/router";
import {StorageKeysEnum} from "../../storage/storage-keys.enum";
import {TokenExpiredTimerService} from "../token-expired-timer/token-expired-timer.service";
import {RedirectService} from "../redirect/redirect.service";
import {LoadingService} from "../loading/loading.service";
import {NotificationConnectionService} from "../notifications/notification-connection.service";

@Injectable({providedIn: "root"})
export class AuthService {

    baseEndpoint: string = ""
    notificationsSeen = sessionStorage.getItem('notificationSeen');

    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private tokenExpiredTimerService: TokenExpiredTimerService,
        private redirectService: RedirectService,
        private loadingService: LoadingService,
        private notificationConnectionService :NotificationConnectionService
    ) {
        this.baseEndpoint = environment.apiTokenUrl;
    }


    refreshToken(headers): Observable<any> {
        return this.httpClient
            .post<any>(`${this.baseEndpoint}/oauth/refresh`,
                {refreshToken: sessionStorage.getItem(StorageKeysEnum.REFRESH_TOKEN)}, {headers: headers}
            );
    }

    refreshWsoToken(): Observable<any> {
        return this.httpClient
            .get<any>(`${this.baseEndpoint}/oauth/wso2/refresh`);
    }

    logOut() {
        if( this.notificationConnectionService.getNoReadNotificationLength() > 0 && this.notificationsSeen == 'true'){
            sessionStorage.setItem('notificationSeen','false')
        }
        const newWindow = window.open('', 'DiscoverBankPage')
        if(newWindow && !newWindow.closed){
            newWindow.close()
        }
        sessionStorage.removeItem('DISCOVER_BANK_TAB_OPEN')
        this.loadingService.show();
        this.redirectService.callRedirectService().subscribe({
            next: isRedirect => {
                this.tokenExpiredTimerService.enableTimer = false
                if (!isRedirect.redirect) {
                    this.noRedirectLogout();
                } else {
                    this.tokenExpiredTimerService.enableTimer = false
                    window.location.href = isRedirect.url;
                }
            },
            error: error => {
                this.tokenExpiredTimerService.enableTimer = false
                console.log(error)
                this.noRedirectLogout();
            }
        })
        let fraudProtection = sessionStorage.getItem('FP_AUTHORIZED');
        if (fraudProtection) {
            sessionStorage.removeItem('FP_AUTHORIZED')
        }
    }

    noRedirectLogout() {
        this.httpClient.post<any>(`${this.baseEndpoint}/oauth/logout`, {
            jwt: sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO),
        }).subscribe({
            next: value => {
                this.removeTokensStorage()
                setTimeout(() => {
                    if (sessionStorage.getItem(StorageKeysEnum.WELCOME) != undefined && sessionStorage.getItem(StorageKeysEnum.TOKEN_FEEDBACK) != undefined) {
                        this.router.navigate(['/feedback']);
                        sessionStorage.removeItem(StorageKeysEnum.WELCOME);
                    } else {
                        location.reload()
                    }
                }, 500)
                return
            },
            error: err => {
                console.log("Error logout: ", err)
                location.reload()
                return
            },
            complete: () => {
                setTimeout(() => {
                    this.loadingService.hide();
                }, 1000)
            }
        });
    }


    public deleteSession() {
        sessionStorage.clear();
    }

    hasTokens() {
        return !!(sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN)
            && sessionStorage.getItem(StorageKeysEnum.REFRESH_TOKEN)
            && sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO))
    }

    validateTokenSession(): Observable<any> {
        const url = `${environment.apiUser}/token/guard/status`;
        return this.httpClient.get(url);
    }

    getHeaders(controlConsulta?: boolean) {
        let cords: any = sessionStorage.getItem(StorageKeysEnum.COORDS);
        const accessTokenWso: any = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO);
        const accessToken: any = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN);
        cords = cords ? JSON.parse(cords) : {};

        return {
            'Authorization-Banca': accessTokenWso,
            'latitud': cords?.lat ? `${cords?.lat}` : '',
            'longitud': cords?.lon ? `${cords?.lon}` : '',
            'client_ip': sessionStorage.getItem(StorageKeysEnum.IP) ? `${sessionStorage.getItem(StorageKeysEnum.IP)}` : '',
            'UserAgent': window.navigator.userAgent,
            'Authorization': `Bearer ${accessToken}`,
            'X-Language': sessionStorage.getItem(StorageKeysEnum.CURRENT_LANGUAGE) ? `${sessionStorage.getItem(StorageKeysEnum.CURRENT_LANGUAGE)}` : 'es'

        }
    }

    removeTokensStorage() {
        sessionStorage.removeItem(StorageKeysEnum.USER_INFO);
        sessionStorage.removeItem(StorageKeysEnum.ACCESS_TOKEN);
        sessionStorage.removeItem(StorageKeysEnum.REFRESH_TOKEN);
        sessionStorage.removeItem(StorageKeysEnum.ACCESS_TOKEN_WSO);
        sessionStorage.removeItem(StorageKeysEnum.JWT_WSO_DECODE);
        sessionStorage.removeItem(StorageKeysEnum.PUBLIC_KEY);
        sessionStorage.removeItem(StorageKeysEnum.PRIVATE_KEY);
        sessionStorage.removeItem(StorageKeysEnum.CONTRACTS_INFORMATION)
        sessionStorage.removeItem(StorageKeysEnum.CURRENT_LANGUAGE)
        sessionStorage.removeItem(StorageKeysEnum.MODAL_DISPLAYED)
        sessionStorage.removeItem(StorageKeysEnum.PERMISSIONS)
        sessionStorage.removeItem(StorageKeysEnum.CONTRACTS_FACMAN)
    }

    getFeedbackToken(jwt) {
        let headers = new HttpHeaders();
        headers = headers.set('Authorization-Banca', jwt);
        this.httpClient
            .get<any>(`${environment.apiUser}/feedback/generate/token`,
                {headers: headers}
            ).subscribe({
            next: value => {
                if (value.code == 1) {
                    sessionStorage.setItem(StorageKeysEnum.TOKEN_FEEDBACK, value.token);
                }
            }
        })
    }

}
